import { createFileRoute } from "@tanstack/react-router";
import SaintBocaRatonPage from "@/pages/learn/SaintBocaRatonPage";
export const Route = createFileRoute("/locations/saint-tms-boca-raton")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® TMS Near Boca Raton | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SAINT® TMS near Boca Raton: 5-day fMRI-guided depression treatment at Neuro Wellness in Coral Springs, FL. Short drive, free consultation, insurance verified.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS Near Boca Raton | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SAINT® TMS near Boca Raton: 5-day fMRI-guided depression treatment at Neuro Wellness in Coral Springs, FL. Short drive, free consultation, insurance verified.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/locations/saint-tms-boca-raton",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/locations/saint-tms-boca-raton",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintBocaRatonPage />;
}
